import React, { useEffect } from 'react'
import Accordion from 'react-bootstrap/Accordion';
import { format } from 'date-fns';
import Offcanvas from 'react-bootstrap/Offcanvas';

export const RemarkModal = ({ id, viewData, handleClose, show }) => {
    // console.log('--------------',viewData);
    // function formatDate(dateString) {
    //     const date = new Date(dateString);
    //     const year = date.getFullYear();
    //     const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
    //     const day = String(date.getDate()).padStart(2, "0");
    //     return `${year}-${month}-${day}`;
    // };
    function formatDate(dateString) {
        if (dateString) {
            const date = new Date(dateString);

            // Check if the date is valid
            if (isNaN(date.getTime())) {
                return ""; // Return an empty string if the date is invalid
            }

            const day = String(date.getDate()).padStart(2, "0");
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const month = monthNames[date.getMonth()];
            const year = date.getFullYear();

            return `${day}-${month}-${year}`;
        }
    }

    function formatTime(dateString) {
        if (!dateString) return 'Invalid date'; // handle cases where dateString is undefined or null

        const date = new Date(dateString);

        // Extract time components
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        // const seconds = String(date.getSeconds()).padStart(2, "0");

        // Return only the formatted time string
        return `${hours}:${minutes}`;
    }
    return (
        <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>View Remark</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {
                    viewData?.quote_remarks?.length > 0 ?
                        <>
                            {viewData?.quote_remarks?.map((value, index) => (
                                <Accordion defaultActiveKey={`${index}`} key={index} className='mb-3'>
                                    <Accordion.Item eventKey={index.toString()} >
                                        <Accordion.Header className='remark-accordion'>
                                            {/* {new Date(value?.created_at).toISOString().split('T')[0]}{" "} */}
                                            <div className="remark-header-content w-100 d-flex justify-content-between">
                                                <span className="remark-user remark-font-14">
                                                    {value?.remark_user? `${value?.remark_user?.name} (${value?.remark_user?.role})` : "-"} 
                                                </span>
                                                <div className='d-flex justify-content-start align-items-center gap-3'>
                                                    <span className="remark-date remark-font-14">{formatDate(value?.createdAt)}</span>
                                                    <span className="remark-date remark-font-14">{formatTime(value?.createdAt)}</span>

                                                </div>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body className="remark-accordion-body-show-query">
                                            {value?.remarks}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            ))}
                        </>
                        :
                        <p>No data available</p>
                }
            </Offcanvas.Body>
        </Offcanvas >
    )
}
